import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["menu", "subCategory"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isString from 'lodash/isString';
import { DEFAULT_SEO_TYPE, SUB_CATEGORY_TO_SEO_TYPE } from './LocalBusinessSchema.constants';
import { getImageSrc } from '../../../../utils/images';
import formatAddress from '../transformers/address';
import { getImage } from '../utils/image';
export function getFirstIfArray(object) {
  if (_isNil(object)) {
    return null;
  }
  if (!_isArray(object)) {
    return object;
  }
  if (!_isEmpty(object)) {
    return object[0];
  }
  return null;
}
export function addIfNotEmpty(object, key, value) {
  if (!_isNil(value) && !_isEmpty(value)) {
    return _objectSpread(_objectSpread({}, object), {}, _defineProperty({}, key, value));
  }
  return object;
}
export function generateOrganizationSchema(name) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SEO_TYPE;
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    url = _ref.url,
    images = _ref.images,
    logo = _ref.logo,
    address = _ref.address;
  var schema = {
    '@context': 'https://schema.org',
    '@type': type,
    name: name
  };
  var imageSrc = getImageSrc(getImage(images));
  var formattedAddress = formatAddress(address);
  schema = addIfNotEmpty(schema, 'url', url);
  schema = addIfNotEmpty(schema, 'logo', logo);
  if (_isString(imageSrc)) {
    schema = addIfNotEmpty(schema, 'image', imageSrc);
  }
  return addIfNotEmpty(schema, 'address', formattedAddress);
}
export function generateFoodEstablishmentSchema(name, type) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    menu = _ref2.menu,
    subCategory = _ref2.subCategory,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var schema = generateOrganizationSchema(name, type, _objectSpread({}, rest));
  return addIfNotEmpty(schema, 'servesCuisine', subCategory);
}
export function getTypeForCategory() {
  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$fallback = _ref3.fallback,
    fallback = _ref3$fallback === void 0 ? DEFAULT_SEO_TYPE : _ref3$fallback;
  if (_isEmpty(category)) {
    return fallback;
  }
  return SUB_CATEGORY_TO_SEO_TYPE[category.toLowerCase()] || fallback;
}
export function getSchemaGeneratorFunction() {
  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var functionByCategory = {
    rest: generateFoodEstablishmentSchema
  };
  return functionByCategory[category.toLowerCase()] || generateOrganizationSchema;
}